import { render, staticRenderFns } from "./CourseRegistrationProgressView.vue?vue&type=template&id=096a0f04&"
import script from "./CourseRegistrationProgressView.vue?vue&type=script&lang=ts&"
export * from "./CourseRegistrationProgressView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports